var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pc_layout"}},[_c('GlobalHeaderPC'),_c('div',{staticClass:"box60"}),_c('router-view'),_c('GlobalFooterPC')],1)}
var staticRenderFns = []

export { render, staticRenderFns }